import React from "react";
import { withTranslation } from "react-i18next";
import { getDateFormat } from "@utils/datePickerUtils";
import { Tooltip } from "react-tooltip";
import { Image } from "hesus-ui-kit";
import priorityUrgentIcon from "@icons/ic-priority-urgent.svg";
import priorityNormalIcon from "@icons/ic-priority-normal.svg";
import priorityLowIcon from "@icons/ic-priority-low.svg";
import priorityNoIcon from "@icons/ic-no-priority.svg";
import { DivToolTip } from "@utils/extra-style";
import "../../EnquiryList.scss";

const EnquiryPriority = (props) => {
  const { t, data, page } = props;

  return (
    <>
      {parseInt(data.priority, 10) === 3 && (
        <>
          <Image
            marginRight={page === "requestView" ? "0.5rem" : "1.5rem"}
            src={priorityLowIcon}
            id={`enquiry-low-tooltip-id${data.id}`}
            className="enquiry-listing__image-priority-icon"
            styles={{
              marginRight: page === "requestView" ? "0.5rem" : "1.5rem",
              width:
                page === "requestView" ? "28px !important" : "45px !important",
            }}
          />
          <Tooltip
            anchorSelect={`#enquiry-low-tooltip-id${data.id}`}
            style={DivToolTip}
            content={
              t("ENQUIRY_PRIORITY_LOW") +
              " - " +
              t("ENQUIRY_DUE_DATE") +
              " " +
              getDateFormat(data.dueDate, "YYYY-MM-DD")
            }
          />
        </>
      )}

      {parseInt(data.priority, 10) === 2 && (
        <>
          <Image
            width={page === "requestView" ? "28px" : "45px"}
            src={priorityNormalIcon}
            id={`enquiry-normal-tooltip-id${data.id}`}
            className="enquiry-listing__image-priority-icon"
            styles={{
              marginRight: page === "requestView" ? "0.5rem" : "1.5rem",
              width:
                page === "requestView" ? "28px !important" : "45px !important",
            }}
          />
          <Tooltip
            anchorSelect={`#enquiry-normal-tooltip-id${data.id}`}
            style={DivToolTip}
            content={
              t("ENQUIRY_PRIORITY_NORMAL") +
              " - " +
              t("ENQUIRY_DUE_DATE") +
              " " +
              getDateFormat(data.dueDate, "YYYY-MM-DD")
            }
          />
        </>
      )}

      {parseInt(data.priority, 10) === 1 && (
        <>
          <Image
            width={page === "requestView" ? "28px" : "45px"}
            src={priorityUrgentIcon}
            id={`enquiry-high-tooltip-id${data.id}`}
            className="enquiry-listing__image-priority-icon"
            styles={{
              marginRight: page === "requestView" ? "0.5rem" : "1.5rem",
              width:
                page === "requestView" ? "28px !important" : "45px !important",
            }}
          />
          <Tooltip
            anchorSelect={`#enquiry-high-tooltip-id${data.id}`}
            style={DivToolTip}
            content={
              t("ENQUIRY_PRIORITY_HIGH") +
              " - " +
              t("ENQUIRY_DUE_DATE") +
              " " +
              getDateFormat(data.dueDate, "YYYY-MM-DD")
            }
          />
        </>
      )}

      {!data.priority && (
        <>
          <Image
            src={priorityNoIcon}
            id={`enquiry-not-defined-tooltip-id${data.id}`}
            className="enquiry-listing__image-priority-icon"
            styles={{
              marginRight: page === "requestView" ? "0.5rem" : "1.5rem",
              width:
                page === "requestView" ? "28px !important" : "45px !important",
            }}
          />
          <Tooltip
            anchorSelect={`#enquiry-not-defined-tooltip-id${data.id}`}
            style={DivToolTip}
            content={t("ENQUIRY_PRIORITY_NOT_DEFINED")}
          />
        </>
      )}
    </>
  );
};

EnquiryPriority.propTypes = {};
export default withTranslation()(EnquiryPriority);
